import script from "./BaseCardTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCardTable.vue?vue&type=script&setup=true&lang=js"

import "./BaseCardTable.vue?vue&type=style&index=0&id=3258178d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3258178d"]])

export default __exports__